import { render, staticRenderFns } from "./FormPreview.vue?vue&type=template&id=18033dcc"
import script from "./FormPreview.vue?vue&type=script&lang=js"
export * from "./FormPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports